import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class DiseasePrevalenceStore {
  diseasesDropDownList: string[] = [];
  diseasesMembersMap: Map<string, any> = new Map<string, any>();

  constructor() {
    makeObservable(this, {
      diseasesDropDownList: observable,
      diseasesMembersMap: observable,
      setDiseasesDropDownList: action,
      removeDiseasesDropDownList: action,
      setDiseasesMembersMap: action,
      removeDiseasesMembersMap: action,
      removeDiseasePrevalenceStoreData: action,
    });

    makePersistable(this, {
      name: 'DiseasePrevalenceStore',
      properties: ['diseasesDropDownList', 'diseasesMembersMap'],
      storage: window.localStorage,
    });
  }

  setDiseasesDropDownList(diseasesDropDownList: string[]) {
    this.diseasesDropDownList = diseasesDropDownList;
  }

  removeDiseasesDropDownList() {
    this.diseasesDropDownList = [];
  }

  setDiseasesMembersMap(diseasesMembersMap: Map<string, any>) {
    this.diseasesMembersMap = diseasesMembersMap;
  }

  removeDiseasesMembersMap() {
    this.diseasesMembersMap = new Map<string, any>();
  }

  removeDiseasePrevalenceStoreData() {
    this.diseasesDropDownList = [];
    this.diseasesMembersMap = new Map<string, any>();
  }
}

export default DiseasePrevalenceStore;
